export default () => {

  apos.util.widgetPlayers.testimonial = {
    selector: '.testimonial-widget',
    player: function (testimonial) {
      if (testimonial) {
        setMinHeight();
        window.addEventListener('resize', () => setMinHeight());

        /**
         * Sets the min-height of testimonial widget
         * to prevent dangling height on carousel slide
         */
        function setMinHeight() {
          const testimonies = testimonial.querySelectorAll('.carousel-item')
          let max = 0;
          testimonies.forEach(testimony => {
            if (!testimony.classList.contains('active')) {
              testimony.classList.add('active');
              max = max < testimony.offsetHeight ? testimony.offsetHeight : max;
              testimony.classList.remove('active');
            }
            else {
              max = max < testimony.offsetHeight ? testimony.offsetHeight : max;
            }
          });
          const carousel = testimonial.querySelector('.carousel-inner');
          carousel.style.minHeight = `${max}px`;
        }
      }
    }
  }
}